/**
 * Dates and times from the server (ISO 8601, UTC) in the user's language and time zone.
 * A text that is not a date is shown as it came, so nothing is hidden.
 */
export function formatDateTime(isoText: string, language: string | undefined): string {
  return formatIso(isoText, language, { dateStyle: "medium", timeStyle: "short" });
}

/** Weekday and time, for moments within the next days (when a snoozed Thread wakes, F44). */
export function formatWeekdayTime(isoText: string, language: string | undefined): string {
  return formatIso(isoText, language, { weekday: "short", hour: "numeric", minute: "2-digit" });
}

/** The day only, for facts whose time of day does not matter (when a capability was observed). */
export function formatDate(isoText: string, language: string | undefined): string {
  return formatIso(isoText, language, { dateStyle: "medium" });
}

function formatIso(isoText: string, language: string | undefined, options: Intl.DateTimeFormatOptions): string {
  const time = Date.parse(isoText);
  if (Number.isNaN(time)) {
    return isoText;
  }
  return new Intl.DateTimeFormat(language, options).format(time);
}
